// extracted by mini-css-extract-plugin
export default {"avatar-container":"user-button_avatar-container__OSOfN","tutor-name":"user-button_tutor-name__FZODL"};